module.exports = __webpack_public_path__ + "static/media/gd.77a468fe.svg";